﻿import { defineComponent, PropType } from 'vue';

import { response_login } from '../../../objects/agent/identity/v1_3/response_login';
import { response_login_payment } from '../../../objects/agent/identity/v1_3/response_login_payment';

export default defineComponent({
    name: "payment_methods",
    props: {
    },
    data() {
        return {
            isOpen: false as Boolean,
            agent_reference: "" as string,
            selected_payment_method: new response_login_payment() as response_login_payment,
            checked_timely: false as Boolean,
            checked_transfer: false as Boolean
        }
    },
    methods: {
        payment_methods(): response_login_payment[] {
            return this.$store.getters.get_Agent_Login?.payment_methods || [];
        },
        display_paymeny_methods(): boolean {
            return (this.payment_methods()?.length > 0);
        },
        Payment_Method_Selected(payment_method: response_login_payment) {
            this.selected_payment_method = payment_method;
            this.Update_Payment_Method();
            this.isOpen = false;
        },
        Initialise_Payment() {
            if (this.$store.getters.get_Agent_Login?.payment_methods?.length > 0) {
                this.selected_payment_method = this.payment_methods()[0];
                this.Update_Payment_Method();
            }
        },
        Update_Payment_Method() {
            this.$store.commit("Set_Payment_Selected", { Selected_Payment: this.selected_payment_method});
            this.$emit("updateMethod", this.selected_payment_method);
            
            if (this.isAgent_Login() && this.isPaymentMethod_BankTransfer() && this.isAAT()) {
                this.agent_reference = this.$store.getters.get_Agent_Login?.agent_reference || this.getBooking_Reference();
                this.$store.commit("Set_isPaymentAcknowledgement_timely_checked", { isPaymentAcknowledgement_timely_checked : false });
                this.$store.commit("Set_isPaymentAcknowledgement_transfer_checked", { isPaymentAcknowledgement_transfer_checked : false });
            }
            else {
                this.$store.commit("Set_isPaymentAcknowledgement_timely_checked", { isPaymentAcknowledgement_timely_checked : undefined });
                this.$store.commit("Set_isPaymentAcknowledgement_transfer_checked", { isPaymentAcknowledgement_transfer_checked : undefined });
            }
        },
        isAgent_Login(): boolean {
            return this.$store.getters.get_Agent_Login?.valid_login == true;
        },
        isAAT(): boolean {
            if (import.meta.env.VITE_DEFAULT_PARENT == "AAT") {
                return true;
            }
            return false;
        },
        isPaymentMethod_BankTransfer(): boolean {
            return (this.selected_payment_method?.method == "BT");
        },
        getBooking_Reference(): string {
            return this.$store.getters.get_Booking.group_booking_id;
        },
        checked_timely_clicked() {
            this.checked_timely = !this.checked_timely;
            this.$store.commit("Set_isPaymentAcknowledgement_timely_checked", { isPaymentAcknowledgement_timely_checked : this.checked_timely});
            this.$emit("updateTimely", this.checked_timely);
        },
        checked_transfer_clicked() {
            this.checked_transfer = !this.checked_transfer;
            this.$store.commit("Set_isPaymentAcknowledgement_transfer_checked", { isPaymentAcknowledgement_transfer_checked : this.checked_transfer});
            this.$emit("updateTransfer", this.checked_transfer);
        }
    },
    mounted() {
        this.Initialise_Payment();
    }
})